<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-card class color="#fafafa">
          <div
            v-for="(color, index) in value"
            :key="index"
            class="d-flex justify-start align-center px-4"
            style="min-height: 80px; width: 100%"
            :style="{background: getColorFromKey(color)}"
          >
            <span :style="{color: getContrastTextColor(getColorFromKey(color))}">
              {{$t(`channelSettings.appearance.themecolors.${color}.label`)}}
              <br />
              {{color.color}}
            </span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="7">
        <v-card color="transparent" flat>
          <v-card-title class="pt-0">{{$t(`channelSettings.appearance.themecolors.title`)}}</v-card-title>
          <v-card-subtitle>{{$t(`channelSettings.appearance.themecolors.subtitle`)}}</v-card-subtitle>
          <v-card-text>
            {{$t(`channelSettings.appearance.themecolors.explanantion`)}}
          </v-card-text>
          <v-card-actions class="px-16 d-flex flex-column justify-start align-start">
            <!-- 
              Fuck this... I don't do this dynamic. This hurt my brain too much right now 
              I do it more static and kinda dirty. But knowhing that it will likely never more than 
              4 colors nobody will ever touch this again or only to delete this part
            -->
            <div class="mb-8">
              <ColorInput v-model="primary" :colorkey="primary.name"/>
              <small>{{$t(`channelSettings.appearance.themecolors.${primary.name}.description`)}}</small>
            </div>
            <div class="mb-8">
              <ColorInput v-model="secondary" :colorkey="secondary.name"/>
              <small>{{$t(`channelSettings.appearance.themecolors.${secondary.name}.description`)}}</small>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import ColorInput from '@/components/channelSettings/ColorInput.vue';
const { mapFields } = createHelpers({
  getterType: 'channelsettings/getField',
  mutationType: 'channelsettings/updateField',
});

export default {
  props: ['value'],
  components: {
    ColorInput,
  },
  data() {
    return {
      colorpickerOpen: false,
      colors: this.value,
    };
  },
  computed: {
    ...mapFields({
      primary: 'appeareance.themecolors.primary',
      secondary: 'appeareance.themecolors.secondary',
    }),
  },
/*   watch: {
  value(oldval, newval ) {
    console.log(oldval, newval);
      // this.$set(this.colors, '', newval);
      // this.colors = Object.assign({}, this.colors, newval);
    }
  }, */
  methods: {
    getColorFromKey(key) {
      return this[key].color;
    },
    getContrastTextColor(hexcolor) {
      // From: https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/
      /*!
       * Get the contrasting color for any hex color
       * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
       * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
       * @param  {String} A hexcolor value
       * @return {String} The contrasting color (black or white)
       */
      // If a leading # is provided, remove it
      if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
      }

      // If a three-character hexcode, make six-character
      if (hexcolor.length === 3) {
        hexcolor = hexcolor
          .split('')
          .map(function(hex) {
            return hex + hex;
          })
          .join('');
      }

      // Convert to RGB value
      var r = parseInt(hexcolor.substr(0, 2), 16);
      var g = parseInt(hexcolor.substr(2, 2), 16);
      var b = parseInt(hexcolor.substr(4, 2), 16);

      // Get YIQ ratio
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;

      // Check contrast
      return yiq >= 128 ? 'black' : 'white';
    }
  }
};
</script>

<style>
</style>